import { render, staticRenderFns } from "./PortabilityRequests.vue?vue&type=template&id=2b6af932&scoped=true"
import script from "./PortabilityRequests.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortabilityRequests.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortabilityRequests.vue?vue&type=style&index=0&id=2b6af932&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6af932",
  null
  
)

export default component.exports